'use client';

import FaqQuestions from '@/components/FaqQuestions';
import Hero from '@/components/Hero';
import { motion } from 'framer-motion';

const page = () => {
    return (
        <>
            {/* Animate Hero */}
            <motion.div
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: 'easeOut' }}
            >
                <Hero
                    heading={
                        <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-tight">
                            FAQs Unveiled: Your Quick Answers Guide
                        </span>
                    }
                    caption={
                        <span className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed">
                            This handy resource covers everything from our
                            services and expertise to project timelines and
                            pricing.
                        </span>
                    }
                    image="/images/faq-vector.png"
                    showShadowOnImage={false}
                />
            </motion.div>

            {/* Animate FAQ Questions */}
            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.8, delay: 0.2 }}
            >
                <div className="px-4 md:px-0">
                    <FaqQuestions />
                </div>
            </motion.div>
        </>
    );
};

export default page;
